import { render } from "./CollaborationCharacteristics.vue?vue&type=template&id=13389b0b"
import script from "./CollaborationCharacteristics.vue?vue&type=script&lang=js"
export * from "./CollaborationCharacteristics.vue?vue&type=script&lang=js"
script.render = render

export default script